import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { IUser } from 'src/app/core/models/user.model';
import { IVehicleModel } from 'src/app/core/models/vehicle.model';
import { IImagesModel } from 'src/app/core/models/image.model';
import {
  NgbModalRef,
  NgbModalOptions,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { VehicleService } from 'src/app/core/services/vehicle.service';
import { TranslateService } from '@ngx-translate/core';
import {
  IImages,
  IVehicleImage,
  IFile,
} from 'src/app/core/models/vehicle-image.model';
import { ToastrService } from 'ngx-toastr';
import * as JSZip from 'jszip';
import { AuthService } from 'src/app/core/services/auth.service';
import { forkJoin, from, Observable, of, Subject, Subscription } from 'rxjs';
import { Role } from 'src/app/core/models/role';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { MessagingService } from 'src/app/core/services/messaging.service';
import {
  skipWhile,
  distinctUntilChanged,
  tap,
  mergeMap,
  finalize,
  takeUntil,
  flatMap,
  map,
} from 'rxjs/operators';
import { FeatureService } from 'src/app/core/services/feature.service';
import { DmsService } from 'src/app/core/services/dms.service';
import { PresetService } from 'src/app/core/services/preset.service';
import { BackgroundService } from 'src/app/core/services/background.service';
import { IPreset } from 'src/app/core/models/preset.model';
import {
  IBackgroundFile,
  IBackgroundModel,
} from 'src/app/core/models/background.model';
import { BackgroundSetupComponent } from '../modals/background-setup/background-setup.component';
import { GifService } from 'src/app/core/services/gif.service';
import { FormArray, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { IFeatureModel } from 'src/app/core/models/feature.model';
import { CarConfiguratorImportComponent } from '../modals/car-configurator-import/car-configurator-import.component';
import { ImporterService } from 'src/app/core/services/importer.service';

@Component({
  selector: 'app-vehicle-item',
  templateUrl: './vehicle-item.component.html',
  styleUrls: ['./vehicle-item.component.css'],
})
export class VehicleItemComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private vehicleService: VehicleService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private userService: UserService,
    private authService: AuthService,
    private previousRouteService: PreviousRouteService,
    private messagingService: MessagingService,
    private dmsService: DmsService,
    private featureService: FeatureService,
    private presetService: PresetService,
    private backgroundService: BackgroundService,
    private gifService: GifService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private importerService: ImporterService
  ) {
    this.form = this.fb.group({
      placeholders: this.fb.array([]),
    });
  }

  user: IUser;
  id: string;
  vehicleData: IVehicleModel = null;
  vehicleDataStart: IVehicleModel = null;
  isVin = false;
  showSave = false;
  createRequest = true;
  userPremium = false;
  catchers: any;
  isRequestedAllready = false;
  clearing = false;
  staticAlertClosed = false;
  previousUrl = '';
  // carousel = $('carousel').carousel();

  exteriorImages: IImagesModel[];
  exteriorImagesSelected: boolean[];
  interiorImages: IImagesModel[];
  interiorImagesSelected: boolean[];
  detailsImages: IImagesModel[];
  detailsImagesSelected: boolean[];
  allImagesSelected: boolean[];
  allVehicleImagesSelected: boolean[];
  allImages: IImagesModel[];

  vehicleImages: IImages[];
  allVehicleImages: IVehicleImage[];
  originalVehicleImages: {};
  imageFiles: any[] = [];
  picPosition: any[] = [];

  imagesToDelete: IImagesModel[];
  imagesToClear: IImagesModel[];
  countToDelete = 0;
  countToClear = 0;
  noExterior = false;
  noInterior = false;
  noDetails = false;
  notUser = false;
  isProcessing = false;
  isMarkerActive: boolean = false;

  // Modal Delete Vehicle
  private modalDeleteVehicle: NgbModalRef;

  private dialogOptionsDelete: NgbModalOptions = {
    backdropClass: 'dark-backdrop-delete',
    centered: true,
    size: 'sm',
    windowClass: 'window-modal-delete',
  };

  // Modals
  private dialogOptionsRequest: NgbModalOptions = {
    backdropClass: 'dark-backdrop-delete',
    centered: true,
    size: 'sm',
    windowClass: 'window-modal-delete',
  };

  private modalDeleteImages: NgbModalRef;
  private modalUploadImage: NgbModalRef;

  request = {
    requestId: '',
    catcherId: '',
    requestMessage: '',
    withBackground: false,
  };

  isDownloading = false;

  // Vin validation data
  // payload: Payload;

  isLoading = false;
  userId;
  selectAll = false;

  selectAllNew = false;

  newImagesToDelete: IVehicleImage[];

  withOriginal = false;

  currentImage: IImagesModel;
  current: number;
  ex = false;
  helpImages: IImagesModel[];
  images: any[];
  newLogic = false;

  file: any;
  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;

  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  compressedExterior: IImagesModel[] = [];
  compressedInterior: IImagesModel[] = [];
  compressedDetails: IImagesModel[] = [];

  imageForUpload: any;
  option: string;

  imageEdit: IVehicleImage;
  mainEdit: any;
  mainEditPath: any;
  originalEdit: IFile;
  edit = false;
  editImageId: string;
  editImagePosition: number;

  upload = false;

  newMainImage: any = null;
  newOriginalImage: any = null;
  originalUpload: any = null;
  mainUpload: any = null;

  newImage = {
    name: 'new background',
    position: 0,
    helpMask: null,
    targetKey: null,
    type: '',
  };

  currentUser: IUser;
  profilesNumber = 1;
  profiles: any[] = [];
  price = 2;
  isDeleted = false;
  vehicleProfile: any;
  toggleImport = false;
  sub: Subscription;
  vehicleStatus = vehicleStatus;
  isImporting = false;
  importStatus = IMPORT_STATUS;

  usersDms: any;
  clientDms: any;
  platformImages: any[] = [];
  panoramaFrontImages: any[] = [];
  panoramaBackImages: any[] = [];
  proVideos: any[] = [];
  panorama: boolean = false;
  show360 = false;
  toggleUpperCase: boolean = false;
  offUpperCaseText = 'Turn off uppercase letters';
  onUpperCaseText = 'Turn on uppercase letters';

  presetTarget: any;
  toggleOpenUploadImage = false;
  toggleAddPreset: boolean = false;
  isAllowed: boolean = true;
  presetsList: IPreset[];
  newBackgrounds: IBackgroundModel[];
  backgroundFiles: IBackgroundFile[] = [];
  @ViewChild('dialogBgSetup') private dialogBgSetup: BackgroundSetupComponent;

  toggleOpenFeatures = false;
  vehicleFeatures = [];
  featuresNames;
  disabledVehicleFeatures = [];
  enabledVehicleFatures = [];

  licensePlates;
  toggleLicensePlate: boolean = false;

  currentLang: string;
  vehiclePreset = null;

  threeSixtyType: string;

  @ViewChild('carConfigModal')
  private carConfigModal: CarConfiguratorImportComponent;

  ngOnInit() {
    this.translate
      .get([
        'features.cutting',
        'features.licensePlateImage',
        'features.reflectiveFloor',
        'features.polishing',
        'features.rimPolishing',
        'features.licensePlateBlur',
        'features.refectiveFloorFull',
        'features.removeReflections',
        'features.platform_360',
      ])
      .subscribe((values) => {
        console.log(values);
        this.featuresNames = values;

        this.featuresNames = Object.entries(values);
      });

    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });

    this.previousUrl = this.previousRouteService.getPreviousUrl().split('?')[0];
    if (this.previousUrl === this.router.url) {
      this.previousUrl = '';
    }

    this.id = this.route.snapshot.params.id;
    this.userId = this.route.snapshot.params.userId || this.currentUser.id;

    this.isLoading = true;
    forkJoin({
      vehicle: this.initializeVehicle(),
      user: this.initializeUser(),
      images: this.getVehicleImages(),
      profiles: this.loadProfiles(),
      licensePlates: this.loadLicensePlates(),
    })
      .pipe(
        flatMap((data) => {
          const clientDmses = this.loadClientDmses(data.user.clientId);
          return forkJoin([clientDmses, of(data)]);
        })
      )
      .subscribe(
        (res) => {
          const [clientDmses, data] = res;
          this.checkVehicleProfile(data.vehicle, data.profiles);

          this.vehicleData = data.vehicle;
          this.user = data.user;
          this.userSettings = data.user.userSettings;
          this.vehicleFeatures = this.vehicleData.vehicleInfo.features;
          this.vehicleImages = data.images;
          this.profiles = data.profiles;
          this.profilesNumber = data.profiles.length;
          this.usersDms = data.profiles[0].dms;
          this.clientDms = clientDmses;
          this.licensePlates = data.licensePlates;
          this.loadFeatures();
          this.checkSettings();

          const presets =
            this.profiles.find(
              (profile) => profile.id === this.vehicleData.vehicleInfo.profileId
            )?.presets || [];

          this.vehiclePreset = presets.find(
            (preset) => preset.id === this.vehicleData.vehicleInfo.presetId
          );

          this.isMarkerActive = !!this.vehicleFeatures.includes('markers');

          if (
            this.vehicleData.vehicleInfo.importStatus ===
            this.importStatus.IMPORTING
          ) {
            this.isImporting = true;
            if (Notification.permission !== 'granted') {
              this.importerInfoPopup = true;
            }
          }

          this.platformImages = this.vehicleImages
            .filter((img) => img.type === 'exterior')
            .sort((a, b) => a.position - b.position)
            .map((img) => img.previewFile.path);

          this.panoramaFrontImages = this.vehicleImages.filter(
            (img) => img.position === -2
          );

          this.panoramaBackImages = this.vehicleImages.filter(
            (img) => img.position === -3
          );

          this.isCarConfImporter = this.vehicleData.vehicleInfo.features.some(feature => feature === 'carconfImport')
        },
        (err) => {
          this.isLoading = false;

          if (err.errorCode === 4040014) {
            this.isDeleted = true;
          }
        }
      );

    this.messagingService.receiveMessage();
    this.sub = this.messagingService.currentMessage
      .pipe(
        tap((data) => {
          console.log('tap', data);
        }),
        skipWhile((value) => value === null),
        distinctUntilChanged(
          (data, secondData) => data.data === secondData.data
        )
      )
      .subscribe((message) => {
        console.log('subscribe', message);
        if (message.data.vehicleId === this.vehicleData.vehicleId) {
          switch (message.data.event) {
            case this.vehicleStatus.IMAGE_PROCESSED:
              this.findImage(message.data, Status.COMPLETED);
              break;
            case this.vehicleStatus.VEHICLE_IMPORTED:
              this.loadVehicle();
              break;
          }
        }
      });

    this.currentLang = this.translate.currentLang;
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.addEventListener('message', (event) => {
    //     this.messagingService.currentMessage.next(event.data);
    //   });
    // }
  }

  loadLicensePlates(): Observable<any> {
    return this.userService.getLicensePlates(this.userId);
  }

  checkSettings() {
    if (this.vehicleData.vehicleInfo.presetId === null) {
      if (!this.user.userSettings.defaultPreset) {
        this.loadUserPresets().subscribe((res) => (this.presetsList = res));
        this.toggleAddPreset = true;
        this.isAllowed = false;
        this.isLoading = false;
      } else if (!this.user.userSettings.defaultBackground) {
        this.isAllowed = false;
        this.isLoading = false;
        this.loadBackgrounds().subscribe((res) => {
          this.newBackgrounds = res;
          this.initializeUserBackgrounds(res);
        });
        setTimeout(() => {
          this.openBgSetupModal();
        }, 300);
      } else {
        this.loadPresetTargets(this.user.userSettings.defaultPreset);
      }
    } else {
      this.loadPresetTargets(this.vehicleData.vehicleInfo.presetId);
    }
  }

  findImage(data, status) {
    if (!this.allVehicleImages) return;

    const img = this.allVehicleImages.find(
      (image) => image.previewFile && image.previewFile.imageId === data.imageId
    );

    if (img !== undefined) {
      img.previewFile.path = data.path;
      img.previewFile.thumbnailPath = data.thumbnailPath;
      img.previewFile.id = data.imageId;
      img.status = status;
    }
  }

  loadVehicle() {
    forkJoin({
      vehicle: this.initializeVehicle(),
      images: this.getVehicleImages(),
    }).subscribe(
      (res) => {
        this.vehicleData = res.vehicle;
        this.vehicleImages = res.images;
        this.initializeImages(this.vehicleImages);

        this.checkImportStatus(this.vehicleData.vehicleInfo.importStatus);

        this.isImporting = false;
      },
      (err) => {
        this.isImporting = false;

        if (err.errorCode === 4040014) {
          this.isDeleted = true;
        }
      }
    );
  }

  loadProfiles(): Observable<any> {
    return this.userService.getSettingsProfiles(this.userId);
  }

  loadClientDmses(clientId): Observable<any> {
    return this.dmsService.getClientDMS(clientId);
  }

  initializeVehicle(): Observable<any> {
    if (this.userId) {
      return this.vehicleService.getVehicleByUserId(this.userId, this.id);
    } else {
      return this.vehicleService.getById(this.id);
    }
  }

  carConfiguratorImporter: any = null;
  isCarConfImporter;
  toggleRequestImages: boolean = false;
  isAnotherImporters: boolean = false;

  checkVehicleProfile(vehicle, profiles) {
    const profile = profiles.find(
      (profile) => profile.id === vehicle.vehicleInfo.profileId
    );

    if (profile) {
      this.vehicleProfile = profile;
        this.carConfiguratorImporter = profile.importers.find(
          (importer) => 
            importer.importer.module === 'carconf' && 
            importer.importer.requiredFeatures.some(
              (feature) => feature.name === 'carconfImport'
            )
        );
        this.isAnotherImporters = profile.importers.some((importer) =>
          importer.importer.module !== 'carconf'
        );
    }
  }

  checkImportStatus(status) {
    let message = '';
    switch (status) {
      case this.importStatus.COMPLETED:
        this.translate
          .get('vehicles.importSuccess')
          .subscribe((text: string) => {
            message = text;
          });
        break;
      case this.importStatus.FAILED:
        this.translate
          .get('vehicles.importingFailed')
          .subscribe((text: string) => {
            message = text;
          });
        break;
      case this.importStatus.NOT_AVAILABLE:
        this.translate
          .get('vehicles.imagesNotAvailable')
          .subscribe((text: string) => {
            message = text;
          });
        break;
    }

    this.toastr.info(message);
  }

  // ! SREDITI DA RADI I KADA KAO CUSTOMER PRVO SELEKTUJES NEKOG USERA
  // ! PA ONDA IZ TOG USERA IZVUCES ID
  // ! TRENUTNO RADI SAMO ZA ULOGOVANOG USERA
  // ? RESENO ????
  initializeUser(): Observable<IUser> {
    if (this.userId) {
      return this.userService.getById(this.userId);
    } else {
      return this.userService.get();
    }
  }

  getVehicleImages(): Observable<IImages[]> {
    return this.vehicleService.getVehicleImages(this.userId, this.id);
  }
  vinImage: any;
  licensePlateNumberImage: any;
  initializeImages(images: IImages[]) {
    let num = this.presetTarget ? this.presetTarget.length : 30;
    let collage: any;
    let gif: any;
    let video: any;
    this.proVideos = [];

    this.presetTarget?.sort(function (a, b) {
      return a.position - b.position;
    });

    images.forEach((img) => {
      if (img.position === 0) {
        collage = img;
      }

      if (img.position === -1) {
        gif = img;
      }

      if (img.position === -4) {
        video = img;
      }

      if ([-5,-6,-7,-8].includes(img.position)) {
        this.proVideos.push(img);
      }
    });

    images.forEach((img) => {
      if (img.type === 'vin') {
        this.vinImage = img;
      }
      if (img.type === 'licensePlateNumber') {
        this.licensePlateNumberImage = img;
      }
    });
    this.allVehicleImages = new Array<IVehicleImage>(num);

    for (let i = 0; i < num; i++) {
      let emptyImage = {} as IVehicleImage;
      emptyImage.previewImageFile = {
        original: '',
        thumbnail: '',
      };
      if (this.presetTarget) {
        emptyImage.position = this.presetTarget[i].position;
        emptyImage.target = this.presetTarget[i];

        const checkShowVideo =
          this.userSettings?.showVideoTutorial !== false &&
          emptyImage.target.videoTutorialFiles?.length;
        if (checkShowVideo) {
          emptyImage.target.videoTutorialFiles?.forEach((video) => {
            if (video.language === this.currentLang) {
              return (emptyImage.target.videoTutorialFileLng = video);
            }
          });
        }
      }
      this.allVehicleImages[i] = emptyImage;
    }

    images.forEach((img) => {
      if (img.position !== 0)
        this.allVehicleImages.map((i, index) => {
          if (i.position === img.position) {
            this.allVehicleImages[index] = img;
          }
        });
    });

    if (collage) {
      this.allVehicleImages.unshift(collage);
    }

    if (gif) {
      this.allVehicleImages.unshift(gif);
    }

    if (video && video.status === 'completed') {
      this.allVehicleImages.unshift(video);
    }

    this.imageFiles = [];

    this.allVehicleImagesSelected = new Array<boolean>(num);
    images.forEach((img) => {
      if (collage) {
        this.allVehicleImagesSelected[img.position] = false;
      } else {
        this.allVehicleImagesSelected[img.position - 1] = false;
      }
    });

    const isCompletedVideo = video?.status === 'completed';

    const shiftValue = [collage, isCompletedVideo, gif]
      .filter(Boolean)
      .length;

    this.allVehicleImages?.forEach((i, index) => {
      i.previewImageFile = {
        original: null,
        thumbnail: null,
      };
      if (this.presetTarget) {
        i.target = this.presetTarget[index - shiftValue];
      }

      if (i.previewFile) {
        i.previewImageFile.original = i.previewFile.path;
        i.previewImageFile.thumbnail = i.previewFile.thumbnailPath;
      }
    });
  }

  sortAlphaNum(a: IVehicleImage, b: IVehicleImage) {
    const reA = /[^a-zA-Z]/g;
    const reN = /[^0-9]/g;

    const aA = a.position.toString().replace(reA, '');
    const bA = b.position.toString().replace(reA, '');
    if (aA === bA) {
      const aN = parseInt(a.position.toString().replace(reN, ''), 10);
      const bN = parseInt(b.position.toString().replace(reN, ''), 10);
      return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
      return aA > bA ? 1 : -1;
    }
  }

  toggleImageForProcess(event, image: IVehicleImage) {
    image.isChecked = event.target.checked;

    image.isChecked
      ? this.imagesToProcess.push(image)
      : this.imagesToProcess.splice(this.imagesToProcess.indexOf(image), 1);

    let isSelected = this.imagesToProcess.some((img) => img.id);

    console.log(isSelected);
    if (!isSelected) {
      this.selectAllNew = false;
    }
  }
  // END select single

  imagesToProcess: IVehicleImage[] = [];

  selectAllImages() {
    console.log('----- SELECT ALL -----');
    this.imagesToProcess = [];
    if (this.selectAllNew) {
      this.allVehicleImages.forEach((img) => {
        if (img.id) img.isChecked = true;
      });
      this.imagesToProcess = [...this.allVehicleImages];
    } else {
      this.allVehicleImages.forEach((img) => {
        if (img.id) img.isChecked = false;
      });
    }
    console.log(this.imagesToProcess);
  }
  // END select all

  showDialogDeleteVehicle(content) {
    this.modalDeleteVehicle = this.modalService.open(
      content,
      this.dialogOptionsDelete
    );
  }

  deleteVehicle() {
    this.vehicleService.delete(this.userId, this.id).subscribe(
      (res) => {
        switch (this.currentUser.role.name) {
          case Role.USER:
            this.router.navigate(['dashboard/vehicles']);
            break;
          case Role.CUSTOMER:
            if (
              this.previousUrl === '/customer/vehicles' ||
              this.previousUrl === ''
            ) {
              this.router.navigate(['customer/vehicles']);
            } else {
              this.router.navigate([`customer/users/${this.userId}/vehicles`]);
            }
            break;
          case Role.CLIENT:
            if (
              this.previousUrl === '/client/vehicles' ||
              this.previousUrl === ''
            ) {
              this.router.navigate(['client/vehicles']);
            } else {
              this.router.navigate([`client/users/${this.userId}/vehicles`]);
            }
            break;
        }
        this.translate
          .get('vehicles.vehicle.vehicleSuccess')
          .subscribe((text: string) => {
            this.toastr.success(text);
          });
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }
  deleteNew(content) {
    if (this.imagesToProcess.length < 1) {
      this.translate
        .get('vehicles.vehicle.extNothingSelected')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return;
    }
    const counter = this.imagesToProcess.filter(
      (item) => item.isChecked
    ).length;
    this.countToDelete = counter;
    console.log('Atempt to delete ' + counter);
    this.modalDeleteImages = this.modalService.open(
      content,
      this.dialogOptionsRequest
    );
  }

  deleteImages() {
    this.modalDeleteImages.close();
    const counter = this.imagesToProcess.filter(
      (item) => item.isChecked
    ).length;
    this.countToDelete = counter;
    this.imagesToProcess.forEach((image) => {
      if (image.isChecked) {
        this.vehicleService
          .deleteNewImage(this.userId, this.vehicleData.vehicleId, image.id)
          .subscribe(
            (res: JSON) => {
              this.translate
                .get('vehicles.vehicle.imageDeleted')
                .subscribe((text: string) => {
                  this.toastr.success(text);
                });
              this.countToDelete--;

              this.checkFinishedDeleting();
            },
            (err) => {
              this.toastr.error(err.message);
            }
          );
      }
    });
  }

  checkFinishedDeleting() {
    if (this.countToDelete < 1) {
      this.translate
        .get('vehicles.vehicle.deleteAllImages')
        .subscribe((text: string) => {
          // this._toastr.success(text);
        });

      this.imagesToProcess = [];
      this.getVehicleImages().subscribe((res) => {
        this.vehicleImages = res;
        this.selectAllNew = false;
        this.initializeImages(this.vehicleImages);
      });
    }
  }

  isVinModel(value, isVin) {
    isVin
      ? (this.vehicleData.vehicleInfo.vin = value)
      : (this.vehicleData.vehicleInfo.licensePlateNumber = value);
  }

  saveVehicle() {
    const body: any = {};

    if (this.toggleEditVin) {
      body.vin = this.vehicleData.vehicleInfo.vin;
    }

    if (this.toggleEditLicensePlate) {
      body.licensePlateNumber = this.vehicleData.vehicleInfo.licensePlateNumber;
    }

    this.vehicleService
      .patch(this.vehicleData.vehicleId, body, this.userId)
      .subscribe(
        (response) => {
          this.initializeVehicle();
          this.translate
            .get('vehicles.vehicle.vehicleUpdated')
            .subscribe((text: string) => {
              this.toastr.success(text);
            });
          this.toggleEditVin = this.toggleEditLicensePlate = false;
        },
        (error) => {
          this.toggleEditVin = this.toggleEditLicensePlate = false;
          this.toastr.error(error.message);
        }
      );
  }

  getFileExtensionFromUrl(url) {
    return url.split(/\#|\?/)[0].split('.').pop().trim();
  }

  downloadImages() {
    if (!this.imagesToProcess.length)
      return this.toastr.info('Nothing selected.');

    this.isDownloading = true;
    const data = [];

    this.imagesToProcess.forEach((image) => {
      if (image.isChecked && image.previewFile) {
        data.push({
          file: image.previewFile,
          position: image.position,
          type: 'main',
        });
      }
      if (
        image.isChecked &&
        this.withOriginal &&
        image.originalFile &&
        image.status === Status.COMPLETED
      ) {
        data.push({
          file: image.originalFile,
          position: image.position,
          type: 'original',
        });
      }
      if (
        image.isChecked &&
        image.type === 'video' &&
        image.status === Status.COMPLETED
      ) {
        data.push({
          file: image.mainFile,
          position: image.position,
          type: 'video',
        });
      }
    });

    if (data.length < 1) {
      this.translate
        .get('vehicles.vehicle.nothingToDownload')
        .subscribe((text: string) => {
          this.toastr.info(text);
        });
      this.isDownloading = false;
      return;
    }

    let files = data.map((item) => item.file.path);

    const zip = new JSZip();
    this.vehicleService.downloadFiles(files).subscribe(
      (responseList) => {
        responseList.forEach((f: Blob, i: number) => {
          let fileExtension = this.getFileExtensionFromUrl(files[i]);
          let filename: string;
          switch (data[i].type) {
            case 'main':
              filename = `image${data[i].position}`;
              break;
            case 'original':
              filename = `image${data[i].position}-original`;
              break;
            case 'video':
              filename = `video${data[i].position}`;
              break;
            default:
              filename = `image${data[i].position}`;
          }
          zip.file(`${filename}.${fileExtension}`, f);
        });
        zip.generateAsync({ type: 'blob' }).then((blob) => {
          const nav = window.navigator as any;
          if (nav.msSaveOrOpenBlob) {
            console.log('IE');
            nav.msSaveBlob(blob, this.vehicleData.vehicleInfo.vin + '.zip');
          } else {
            console.log('chrome');
            const a: any = document.createElement('a');
            document.body.appendChild(a);

            a.style.cssText = 'display: none';
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = this.vehicleData.vehicleInfo.vin + '.zip';
            a.click();
            window.URL.revokeObjectURL(url);
          }

          this.isDownloading = false;
        });
      },
      (error) => {
        // this._toastr.error(error.error.message);
        this.isDownloading = false;
      }
    );
  }

  openNewImageModal(
    index,
    imageData,
    panoramaFront: boolean,
    panoramaBack: boolean
  ) {
    this.newLogic = true;

    this.images = [];
    let count = 0;
    let noImages = 0;
    let helpIndex = 0;
    this.panorama = panoramaFront || panoramaBack;

    if (imageData) {
      this.currentImage = imageData;
    } else if (panoramaFront) {
      this.panoramaFrontImages.forEach((img) => {
        if (count === index) {
          helpIndex = index - noImages;
        }
        count++;
        this.images.push(img);
      });
      this.currentImage = this.images[helpIndex];
      this.current = helpIndex;
    } else if (panoramaBack) {
      this.panoramaBackImages.forEach((img) => {
        if (count === index) {
          helpIndex = index - noImages;
        }
        count++;
        this.images.push(img);
      });
      this.currentImage = this.images[helpIndex];
      this.current = helpIndex;
    } else {
      this.allVehicleImages.forEach((img) => {
        // console.log("count: " + count + " , index: " + index)
        if (count === index) {
          helpIndex = index - noImages;
        }
        count++;
        img.previewImageFile.original != null ||
        img.mainFile?.path.includes('mp4')
          ? this.images.push(img)
          : noImages++;
      });
      this.currentImage = this.images[helpIndex];
      this.current = helpIndex;
    }

    this.ex = true;
  }

  exitImagePreview() {
    this.ex = false;
  }

  uploadOldImage() {
    console.log(this.option);
    this.modalUploadImage.close();

    const formData: FormData = new FormData();
    formData.append('image', this.imageForUpload, this.imageForUpload.name);
    this.vehicleService.addImage(formData, this.id, this.option).subscribe(
      (res) => {
        //   this._toastr.success("proslo");
        this.initializeVehicle();
        this.getVehicleImages();
      },
      (err) => {}
    );
  }
  editImage(index, imgType) {
    if (imgType === 'fillableImage') {
      this.onEditFillableImage(index);
    } else {
      this.edit = true;
      this.mainEdit = undefined;
      this.mainEditPath = undefined;
      this.originalEdit = undefined;
      this.mainUpload = null;
      this.editImageId = '';

      this.imageEdit = this.allVehicleImages[index];
      this.editImageId = this.allVehicleImages[index].id;
      this.editImagePosition = this.allVehicleImages[index].position;

      if (this.imageEdit.id !== '') {
        this.newImage.type = this.imageEdit.type;
      } else {
        this.newImage.type = '0';
      }

      if (this.imageEdit.files && this.imageEdit.files.length) {
        this.imageEdit.files.forEach((file) => {
          if (file.type === 'main') {
            this.mainEdit = file;
            this.mainEditPath = file.path;
          }
        });
      } else {
        this.mainEdit = undefined;
        this.originalEdit = undefined;
      }
    }
  }

  toggleEditFillableImage = false;
  selectedFillableImagePath = null;
  placeholders: any[] = []; // To hold the fetched placeholders
  textPlaceholders: any[] = []; // To hold the fetched placeholders
  formGroups: FormGroup[] = []; // To hold FormGroups for each placeholder
  form: FormGroup;
  canSeeForm = false;

  onEditFillableImage(index) {
    this.selectedFillableImagePath =
      this.allVehicleImages[index]?.previewFile?.path;
    const imgPosition = this.allVehicleImages[index].position;

    const target = this.vehiclePreset?.targets?.find(
      (target) => target.position === imgPosition
    );
    console.log(target);

    if (!target) {
      return;
    }

    const textPlaceholders = target.textPlaceholders || [];
    this.textPlaceholders = textPlaceholders;

    if (!textPlaceholders.length) {
      this.toggleEditFillableImage = true;
      return;
    }

    const placeholderIds = textPlaceholders.map((p) => p.id);

    this.fetchAllPlaceholders(placeholderIds).subscribe(
      (res) => {
        this.placeholders = this.mapValuesToPlaceholders(textPlaceholders, res);

        this.createPlaceholderForms();

        this.toggleEditFillableImage = true;
      },
      (err) => {}
    );
  }

  fetchPlaceholderById(placeholderId: string) {
    return this.vehicleService
      .getPlaceholderValues(this.id, placeholderId)
      .pipe(map((res) => ({ ...res, placeholderId })));
  }

  fetchAllPlaceholders(ids: string[]) {
    const requests = ids.map((id) => this.fetchPlaceholderById(id));

    return forkJoin(requests);
  }

  mapValuesToPlaceholders(placeholders: any[], values: any[]): any[] {
    return placeholders.map((placeholder) => {
      const valueObject = values.find(
        (val) => val.placeholderId === placeholder.id
      );

      placeholder.fields = placeholder.fields.map((field) => ({
        ...field,
        value: valueObject ? valueObject[field.key] : '',
      }));

      return placeholder;
    });
  }

  createPlaceholderForms() {
    this.canSeeForm = false;
    const placeholderArray = this.form.get('placeholders') as FormArray;
    this.placeholders.forEach((placeholder) => {
      const placeholderGroup = this.fb.group({
        id: [placeholder.id],
        name: [placeholder.name],
        fields: this.fb.array(this.createFieldControls(placeholder.fields)),
      });
      placeholderArray.push(placeholderGroup);
    });

    setTimeout(() => {
      this.canSeeForm = true;
      this.cdr.detectChanges(); // Run change detection explicitly
    });
  }

  createFieldControls(fields: any[]): FormGroup[] {
    return fields.map((field) =>
      this.fb.group({
        key: [field.key],
        value: [field.value, field.required ? Validators.required : null],
      })
    );
  }

  get placeholdersArray() {
    return this.form.get('placeholders') as FormArray;
  }

  getFieldsArray(placeholderGroup: FormGroup) {
    return placeholderGroup.get('fields') as FormArray;
  }

  onSubmit() {
    const formData = this.form.value.placeholders;

    const updateRequests = formData.map((placeholder) => {
      const values = placeholder.fields.reduce((acc, field) => {
        acc[field.key] = field.value;
        return acc;
      }, {});

      return {
        textPlaceholderId: placeholder.id,
        values: values,
      };
    });

    this.vehicleService.setPlaceholderValues(this.id, updateRequests).subscribe(
      (responses) => {
        this.toggleEditFillableImage = false;
        this.placeholders = [];
        this.form.reset();
        this.form = this.fb.group({
          placeholders: this.fb.array([]),
        });

        this.translate
          .get('fillableImage.placeholderValuesSuccess')
          .subscribe((text: string) => {
            this.toastr.success(text);
          });
      },
      (err) => {
        if (err.errorCode === 4220002) {
          this.translate.get('errors.alreadyOnProcessing').subscribe((text: string) => {
            this.toastr.error(text);
          });
        }
        console.error('Error updating placeholders:', err);
      }
    );
  }

  onCloseEditFillableImage() {
    this.toggleEditFillableImage = false;
    this.placeholders = [];
    this.form.reset();
    this.form = this.fb.group({
      placeholders: this.fb.array([]),
    });
  }

  exitImageEdit() {
    this.edit = false;
    this.mainUpload = null;
    this.imageForUpload = null;
  }

  fileSelect(content) {
    // event.preventDefault();
    const element: HTMLElement = document.getElementById(
      `file-${content}`
    ) as HTMLElement;
    element.click();
  }

  getFile(event) {
    this.imageForUpload = null;

    if (event.target.files && event.target.files[0]) {
      this.imageForUpload = event.target.files[0];

      const checkimg = this.imageForUpload.name.toLowerCase();
      if (!checkimg.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG)$/)) {
        // this._toastr.error("Please enter Image File Extensions");
        return false;
      }

      /*if (this.editImageId !== '') {
        this.showFile(this.imageForUpload, 'main');
        // state === 'add' ?
        // this.addImageFile(this.imageForUpload, type) : this.patchImageFile(this.imageForUpload, type)
      } else {
        this.newImage.position = this.editImagePosition;
        const imageType = this.getImageType(this.imageForUpload);
        imageType != undefined ? this.newImage.type = imageType : this.newImage.type = 'exterior';
        this.newImage.name = this.imageForUpload.name;
        this.showFile(this.imageForUpload, 'main');
      }*/
      this.showFile(this.imageForUpload, 'main');
    }
  }

  addImageFile(image, type) {
    const formData: FormData = new FormData();
    formData.append('image', image);

    if (image == undefined) {
      return this.translate
        .get('vehicles.vehicle.selectImageFirst')
        .subscribe((text: string) => {
          // this._toastr.error(text);
        });
    }

    this.vehicleService
      .addImageFile(formData, this.editImageId, type)
      .subscribe(
        (res) => {
          // this._toastr.success("File successfully added.")
          this.ngOnInit();
        },
        (err) => {}
      );

    this.edit = false;
  }

  patchImageFile(image, type) {
    const formData: FormData = new FormData();
    formData.append('image', image);

    if (image == undefined) {
      return this.translate
        .get('vehicles.vehicle.selectImageFirst')
        .subscribe((text: string) => {
          // this._toastr.error(text);
        });
    }

    let fileId;
    type === 'main'
      ? (fileId = this.mainEdit.id)
      : (fileId = this.originalEdit.id);

    this.vehicleService
      .patchImageFile(formData, this.editImageId, fileId)
      .subscribe(
        (res) => {
          // this._toastr.success("File successfully changed.")
          this.ngOnInit();
        },
        (err) => {}
      );

    this.edit = false;
  }

  getImageType(image) {
    const x = image.name.split('__');
    console.log(x);
    let type;

    if (x[4] != undefined) {
      switch (x[4]) {
        case 'ext':
          type = 'exterior';
          break;
        case 'int':
          type = 'interior';
          break;
        case 'det':
          type = 'details';
          break;
        case 'non':
          type = 'details';
          break;
        default:
          break;
      }
    }

    return type;
  }

  showFile(image, type) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        if (type === 'main') {
          this.mainUpload = reader.result;
          this.mainEditPath = reader.result;
        }
        // type == 'main' ? this.mainUpload = reader.result : this.originalUpload = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  importerInfoPopup = false;
  isImportedInfo = false;

  openImportModal(importAgain?: boolean) {
    if (importAgain) {
      this.isImportedInfo = false;
      this.toggleImport = true;
    } else {
      this.vehicleData.vehicleInfo.importStatus !==
      this.importStatus.NOT_IMPORTED
        ? (this.isImportedInfo = true)
        : (this.toggleImport = true);
    }
  }

  importImages(importerId) {
    this.toggleImport = false;

    this.vehicleService
      .importImages(this.userId, importerId, this.vehicleData.vehicleId)
      .subscribe((res) => {
        if (Notification.permission !== 'granted') {
          this.importerInfoPopup = true;
        } else {
          this.isImporting = true;
        }
      });
  }

  processVehicle() {
    this.isProcessing = true;
    let force = false;

    if (this.currentUser.role.name === Role.ROOT) {
      force = true;
    }

    this.vehicleService
      .processVehicle(this.userId, this.vehicleData.vehicleId, force)
      .subscribe(
        (res) => {
          this.translate
            .get('vehicles.sentOnProcessing')
            .subscribe((text: string) => {
              this.toastr.success(text);
            });
          switch (this.currentUser.role.name) {
            case Role.ROOT: {
              this.router.navigate(['root/vehicles/']);
              break;
            }
            case Role.CUSTOMER: {
              this.router.navigate(['customer/vehicles/']);
              break;
            }
            case Role.CLIENT: {
              this.router.navigate(['client/vehicles/']);
              break;
            }
            default: {
              this.router.navigate(['dashboard/vehicles/']);
              break;
            }
          }
        },
        (err) => {
          this.isProcessing = false;
          this.toastr.error(err.message);
        }
      );
  }

  processImage() {
    if (!this.imagesToProcess.length)
      return this.toastr.info('Nothing selected.');

    this.imagesToProcess.forEach((image) => {
      if (image.isChecked) {
        this.vehicleService
          .processImage(this.userId, image.id)
          .subscribe((res) => {
            console.log(res);
            this.toastr.success(
              'Images sent sent on processing, refresh the page after some time to see the result'
            );
          });
      }
    });
  }

  toggleDecodeInfo = false;
  isDecoding = false;
  decodeVinFeature;
  toggleVehicleDetails = false;
  toggleEditVin = false;
  toggleEditLicensePlate = false;
  decodeVinText = 'Click to decode VIN';
  onDecode() {
    this.featureService.getAllFeatures().subscribe(
      (res) => {
        this.decodeVinFeature = res.find((f) => f.name === 'decodeVin');
        this.toggleVehicleDetails = false;
        this.toggleDecodeInfo = true;
      },
      (err) => {}
    );
  }

  decodeVin() {
    const vin = this.vehicleData.vehicleInfo.vin;
    this.toggleDecodeInfo = false;

    if (vin.length === 17) {
      this.isDecoding = true;
      this.vehicleService.decodeVin(this.user.id, vin).subscribe(
        (res) => {
          this.vehicleData.vehicleInfo.vinInformations = [res];
          this.toggleVehicleDetails = true;
          this.isDecoding = false;
        },
        (err) => {
          if (err.errorCode === 4000034) {
            this.translate
              .get('vehicles.decodeVinError')
              .subscribe((text: string) => {
                this.toastr.error(text);
              });
          } else {
            this.toastr.error(err.message);
          }
          this.isDecoding = false;
        }
      );
    } else {
      this.translate.get('errors.vinShouldBe', { vin: vin }).subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
  }

  ngOnDestroy() {
    console.log('pozivamo destroy');
    this.sub.unsubscribe();
    this.messagingService.currentMessage.next(null);
    this.endSubs$.next();
    this.endSubs$.complete();
  }

  uploadToInterface(dmsId) {
    const image = this.allVehicleImages.filter(
      (img) => img.previewImageFile.original !== null
    );
    if (image.length) {
      this.dmsService
        .uploadVehicleToDms(this.userId, dmsId, this.vehicleData.vehicleId)
        .subscribe(
          (res) => {
            this.toastr.success(`Images are uploaded to the interface.`);
          },
          (err) => {
            if (err['errorCode'] === 4220010) {
              this.translate.get('errors.missingRequiredFeatures').subscribe((text: string) => {
                this.toastr.error(text);
              });
            } else {
              this.toastr.error(`Ups, something wrong.`);
            }
          }
        );
    } else {
      this.toastr.error(`There are no images.`);
    }
  }

  toggleOpenClientDMS = false;
  isUploading = false;
  uploadToClientInterface(dmsId) {
    const image = this.allVehicleImages.filter(
      (img) => img.previewImageFile.original !== null
    );
    if (image.length) {
      const body = {
        userId: this.userId,
        vehicleId: this.vehicleData.vehicleId,
      };

      this.isUploading = true;
      this.dmsService
        .uploadVehicleToClientDms(this.user.clientId, dmsId, body)
        .subscribe(
          (res) => {
            this.toastr.success(`Images are uploaded to the interface.`);
            this.toggleOpenClientDMS = false;
            this.isUploading = false;
          },
          (err) => {
            console.log(err);
            this.toggleOpenClientDMS = false;
            this.isUploading = false;
            if (err['errorCode'] === 4220010) {
              this.translate.get('errors.missingRequiredFeatures').subscribe((text: string) => {
                this.toastr.error(text);
              });
            } else {
              this.toastr.error(`Ups, something wrong.`);
            }
          }
        );
    } else {
      this.toastr.error(`There are no images.`);
    }
  }

  toggleRestoreImages = false;
  restoredImages = [];
  private endSubs$ = new Subject();
  selectedDeletedImages = [];

  onRestoreImages() {
    this.isLoading = true;
    this.vehicleService
      .deletedVehicleImages(this.userId, this.vehicleData.vehicleId)
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.restoredImages = res.filter((img) => img.files.length);
          this.toggleRestoreImages = true;
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  selectAllDeleted = false;
  selectAllDeletedImages() {
    this.selectedDeletedImages = [];
    if (this.selectAllDeleted) {
      this.restoredImages.forEach((img) => {
        if (img.id) img.isChecked = true;
      });
      this.selectedDeletedImages = [...this.restoredImages];
    } else {
      this.restoredImages.forEach((img) => {
        if (img.id) img.isChecked = false;
      });
    }
  }

  onCloseRestore() {
    this.toggleRestoreImages = false;
    this.selectAllDeleted = false;
  }

  toggleImageForRestore(event, image: IVehicleImage) {
    image.isChecked = event.target.checked;

    image.isChecked
      ? this.selectedDeletedImages.push(image)
      : this.selectedDeletedImages.splice(
          this.selectedDeletedImages.indexOf(image),
          1
        );

    let isSelected = this.selectedDeletedImages.some((img) => img.id);

    if (!isSelected) {
      this.selectAllDeleted = false;
    }
  }

  restoreImagesHandler() {
    if (!this.selectedDeletedImages.length) {
      return;
    }

    if (
      this.selectedDeletedImages
        .map((image) => image.position)
        .filter((item, index, a) => a.indexOf(item) !== index).length
    ) {
      return this.toastr.error(
        `You can not select multiple images with same position.`
      );
    }

    // from(this.selectedDeletedImages)
    //   .pipe(
    //     map(img => this.vehicleService.restoreVehicleImage(this.userId, this.vehicleData.vehicleId, img.id)),
    //     concatAll()
    //   )
    //   .subscribe(
    //     res => { console.log(res) },
    //     err => { console.log(err) },
    //     () => { console.log('ende') }
    //   );

    from(this.selectedDeletedImages)
      .pipe(
        /* merge each file to an Observable */
        mergeMap((img) =>
          this.vehicleService.restoreVehicleImage(
            this.userId,
            this.vehicleData.vehicleId,
            img.id
          )
        ),
        finalize(() => {
          this.toastr.success('Finished restoring images.');
          this.onCloseRestore();
          this.getVehicleImages().subscribe(
            (res) => {
              this.vehicleImages = res;
              this.initializeImages(this.vehicleImages);
            },
            (err) => {}
          );
        }),

        /* cancel any pending requests when the component unloads.
          this will avoid any RxJS memory leaks */
        takeUntil(this.endSubs$)
      )
      .subscribe(
        (res) => {},
        (err) => {
          // this.toastr.error('One or more images have failed.');
          this.toastr.error(err.message);
        },
        () => {
          this.selectedDeletedImages = [];
        }
      );
  }

  downCase() {
    this.toggleUpperCase = !this.toggleUpperCase;
  }

  selectedTarget: any;

  openUploadOriginalImage(image: any) {
    this.toggleOpenUploadImage = true;
    this.selectedTarget = image.target;
    console.log(this.allVehicleImages)
    console.log(this.selectedTarget)
  }

  showVideoTutorial: boolean = false;
  selectedVideo: any;
  openVideoTutorial(video: any) {
    this.showVideoTutorial = true;
    this.selectedVideo = video.fileInfo.path;
  }

  isUploadingOriginal = false;

  uploadOriginalImage() {

    if (this.isUploadingOriginal) return;
    this.isUploadingOriginal = true;

    if (!this.imageForUpload) {
      this.isUploadingOriginal = false;
      this.toastr.error('Please select image first.');
      return;
    }

    const formData = new FormData();
    formData.append('name', this.imageForUpload.name);
    formData.append('position', this.selectedTarget.position);
    formData.append('type', this.selectedTarget.clearType);

    if (this.selectedTarget.helpMask !== '') {
      formData.append('helpMask', this.selectedTarget.helpMask);
    }

    formData.append('targetId', this.selectedTarget.targetId);
    formData.append('files', this.imageForUpload);
    formData.append('presetTargetId', this.selectedTarget.id);

    this.vehicleService
      .uploadOriginalImage(this.userId, this.vehicleData.vehicleId, formData)
      .pipe(
        finalize(() => this.isUploadingOriginal = false)
      )
      .subscribe({
        next: () => {
          this.toastr.success('File successfully uploaded.');
          this.refresh();
        },
        error: (err) => {
          this.toastr.error(err?.message || 'Upload failed');
        }
      });
  }
  
  refresh() {
    this.getVehicleImages().subscribe((res) => {
      this.vehicleImages = res;
      this.initializeImages(this.vehicleImages);
      this.toggleOpenUploadImage = false;
    });
  }

  is360Platform = false;
  isUpdating = false;
  userSettings;
  features;

  loadPresetTargets(presetId) {
    this.presetService.getPresetTargets(presetId).subscribe((res) => {
      this.presetTarget = res;
      this.initializeImages(this.vehicleImages);
      this.isLoading = false;
      this.isAllowed = true;
    });
  }

  loadUserPresetTargets() {
    this.initializeUser().subscribe((res) => {
      this.user = res;
      this.loadPresetTargets(this.user.userSettings.defaultPreset);
    });
  }

  loadUserPresets(): Observable<IPreset[]> {
    return this.presetService.getPresetsOfUser(this.userId);
  }
  loadBackgrounds(): Observable<IBackgroundModel[]> {
    return this.backgroundService.getUserBackgrounds(this.userId);
  }

  initializeUserBackgrounds(bg) {
    this.backgroundFiles = [];
    if (this.user.userSettings) {
      bg?.forEach((background) => {
        background.allowedTypes.forEach((type) => {
          if (type == this.user.userSettings.backgroundType) {
            background.backgroundFiles.forEach((file) => {
              if (file.parameter === 'preview') {
                this.backgroundFiles = this.backgroundFiles.concat(file);
              }
            });
          }
        });
      });
    }
  }
  async openBgSetupModal() {
    return await this.dialogBgSetup.open();
  }

  loadFeatures() {
    this.featureService.getAllFeatures().subscribe(
      (res) => {
        this.decodeVinFeature = res.find((f) => f.name === 'decodeVin');
        this.features = res;
        this.features = this.features.filter(
          (feature) => feature.name !== 'createVehicle' && feature.name !== 'decodeVin'
        );
        this.features.forEach((feature) => {
          this.featuresNames.forEach((name) => {
            if (feature.name === name[0].split('.')[1]) {
              feature.displayName = name[1];
            }
          });
        });
        this.features.forEach((feature) => {
          this.isActiveFeature(feature);
          this.isFeatureDisabled(feature);
        });
      },
      (err) => {}
    );
  }

  isActiveFeature(feature) {
    if (this.vehicleFeatures.includes(feature.name)) {
      feature.isChecked = true;
      this.enabledVehicleFatures.push(feature);
    } else {
      feature.isChecked = false;
      this.disabledVehicleFeatures.push(feature);
    }
  }

  isFeatureDisabled(feature: IFeatureModel) {
    if (this.userSettings.userSettingsMode === 'client') {
      return (feature.isDisabled = true);
    }

    let counter = 0;
    let conflictsCounter = 0;
    if (feature.dependencies.length) {
      feature.dependencies.forEach((dep, index) => {
        if (this.vehicleFeatures.includes(dep)) {
          counter++;
        }
      });
      if (counter === feature.dependencies.length) {
        feature.isDisabled = false;
      } else {
        feature.isDisabled = true;
      }
    }

    if (feature.conflicts.length) {
      feature.conflicts.forEach((dep, index) => {
        if (this.vehicleFeatures.includes(dep)) {
          conflictsCounter++;
        }
      });

      conflictsCounter === feature.conflicts.length
        ? (feature.isDisabled = true)
        : null;
    }

    if (
      this.userSettings.defaultCropType !== 'full' &&
      (feature.name === 'reflectiveFloor' ||
        feature.name === 'refectiveFloorFull')
    ) {
      feature.isDisabled = true;
    }

    if (feature.name === 'platform_360') {
      feature.isDisabled = true;
    }
  }

  patchFeature(data) {
    if (
      data.feature.name === 'licensePlateImage' &&
      !this.userSettings.defaultLicensePlate
    ) {
      data.event.preventDefault();
      return this.translate.get('errors.defaultLicensePlateRequired').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    const isChecked = data.event.target.checked;
    if (isChecked) {
      const body = {
        features: [data.feature.name],
      };
      this.updateVehicleFeatures(body);
    }
  }

  updateVehicleFeatures(body) {
    this.isUpdating = true;
    this.enabledVehicleFatures = [];
    this.disabledVehicleFeatures = [];
    this.vehicleService
      .editVehicleFeatures(this.userId, this.vehicleData.vehicleId, body)
      .subscribe(
        (res) => {
          this.vehicleFeatures = res.features;
          this.loadFeatures();
          this.isUpdating = false;
          this.toastr.success('Successfully updated Feature');
        },
        (err) => {
          console.log(err);
        }
      );
  }

  updateSettings(body) {
    this.isUpdating = true;
    this.userService.patchUserSettings(this.userId, body).subscribe(
      (settings) => {
        this.userSettings = settings;

        this.is360Platform = settings.features.includes('platform_360');
        this.isUpdating = false;
      },
      (err) => {
        this.isUpdating = false;
      }
    );
  }

  patchPreset(event) {
    const preset = event.target.value;

    const body = {
      defaultPreset: preset,
    };

    this.updateSettings(body);

    if (!this.user.userSettings.defaultBackground) {
      this.isAllowed = false;
      this.toggleAddPreset = false;
      this.loadBackgrounds().subscribe((res) => {
        this.newBackgrounds = res;
        this.initializeUserBackgrounds(res);
      });
      this.loadUserPresetTargets();
      setTimeout(() => {
        this.isAllowed = false;
        this.openBgSetupModal();
      }, 400);
    } else {
      this.isAllowed = true;
      this.toggleAddPreset = false;
      this.loadUserPresetTargets();
    }
  }

  SaveBgSetup({ body, newFeatures }) {
    if (newFeatures) {
      body['features'] = [...newFeatures];
    }

    this.updateSettings(body);
    this.loadUserPresetTargets();
    this.isAllowed = true;
  }

  toggleMakeGIF = false;

  onMakeGIF() {
    this.toggleMakeGIF = true;
  }

  makeGIF() {
    this.gifService.makeGif(this.userId, this.vehicleData.vehicleId).subscribe(
      (res) => {
        this.loadVehicle();
        this.toggleMakeGIF = false;
      },
      (err) => {
        this.toastr.error('Error on making GIF');
      }
    );
  }

  toggleDuplicateVehicle = false;

  onDuplicateVehicle() {
    this.toggleDuplicateVehicle = true;
  }

  toggleSelected(option) {
    if (option.subOptions.find((x) => x.selected) == null)
      option.selected = false;

    if (option.subOptions.find((x) => !x.selected) == null)
      option.selected = true;
  }

  loadUserSettings(userId, profileId) {
    return this.userService.getUserSettings(userId, profileId);
  }

  duplicateVehicle(form: NgForm) {
    let chooseProfile = [];
    const selectedProfiles = Object.fromEntries(
      Object.entries(form.form.value).filter(([key, value]) => value === true)
    );
    if (
      Object.keys(selectedProfiles).length === 0 &&
      selectedProfiles.constructor === Object
    ) {
      return this.translate.get('errors.selectProfile').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
    Object.keys(selectedProfiles).map((item) => {
      chooseProfile.push(
        this.profiles.filter((profile) => profile['name'] == item)
      );
    });

    let copyVehicleId = this.vehicleData.vehicleId;

    chooseProfile.map((profile) =>
      this.loadUserSettings(this.userId, profile[0].id).subscribe((res) => {
        this.userSettings = res;
        this.price = 2;
        this.features.forEach((feature) => {
          if (this.userSettings.features.includes(feature.name)) {
            this.price += feature.price;
          }
        });
        let vin = this.vehicleData.vehicleInfo.vin;

        this.vehicleService
          .add(this.user.id, {
            vin: vin.toUpperCase(),
            forceProfileId: profile[0].id,
            copyVehicleId: copyVehicleId,
          })
          .subscribe(
            (response) => {
              this.translate
                .get('vehicles.vehicleAddedInfo')
                .subscribe((text: string) => {
                  this.toastr.success(text);
                });
              if (['user'].includes(this.currentUser.role.name)) {
                this.user.client.credits -= this.price;
                this.authService.setUser(this.user);
              }
            },
            (error) => {
              this.toastr.error(error.message);
            }
          );
      })
    );

    setTimeout(() => {
      switch (this.currentUser.role.name) {
        case Role.CUSTOMER: {
          this.router.navigate(['customer/vehicles/']);
          break;
        }
        case Role.CLIENT: {
          this.router.navigate(['client/vehicles/']);
          break;
        }
        default: {
          this.router.navigate(['dashboard/vehicles/']);
          break;
        }
      }
    }, 800);
  }

  patchLicensePlate(plate) {
    let body = {
      licensePlateId: plate?.id || null,
    };
    this.vehicleService
      .editVehichle(this.user.id, this.vehicleData.vehicleId, body)
      .subscribe(
        (response) => {
          this.toastr.success('Successfully changed License Plate Image!');
          this.vehicleData.vehicleInfo.licensePlateId = plate.id;
        },
        (error) => {
          this.toastr.error(error.message);
        }
      );
    this.toggleLicensePlate = false;
  }

  isProcessingVehicle() {
    return !!['processing', 'pending', 'qc'].includes(
      this.vehicleData?.vehicleInfo.status
    );
  }

  checkIsThreeSixtyAvailable(): boolean {
    if (
      this.vehicleData.vehicleInfo.status !== 'qc' &&
      this.vehicleData.vehicleInfo.features.includes('platform_360') &&
      this.user.customer.createGifEnabled
    ) {
      this.threeSixtyType = 'GIF';
      return true;
    } else if (
      this.vehicleData.vehicleInfo.status !== 'qc' &&
      this.vehicleData.vehicleInfo.features.includes('platform_360') &&
      this.user.customer.threeSixtyVideo
    ) {
      this.threeSixtyType = 'Video';
      return true;
    } else {
      this.threeSixtyType = null;
      return false;
    }
  }

  selectedImporterId: string;
  toggleConfirmRequestImages: boolean = false;
  carConfImporter: any;
  sortByImg: boolean = false;

  importImagesFromCarConf(importerId: string) {
    this.toggleImport = false;
    let body = {
      mode: 'auto',
    };
    
    this.vehicleService
      .importImages(this.userId, importerId, this.vehicleData.vehicleId, body)
      .subscribe((res) => {
        if (Notification.permission !== 'granted') {
          this.importerInfoPopup = true;
        } else {
          this.isImporting = true;
        }
      },
      (err) => {
        if (err['errorCode'] === 4040068) {
          this.openCarConfigVehicle(this.carConfiguratorImporter.importerId)
         //this.toggleRequestImages = true;
         //this.selectedImporterId = importerId;
        }
        if (err['errorCode'] === 4030047) {
          this.translate.get('errors.imagesAlreadyImport').subscribe((text: string) => {
            this.toastr.error(text);
          });
        }
       
      })
  }

  openListCarConfigVehicles() {
    this.openCarConfigVehicle(this.carConfiguratorImporter.importerId);
    this.toggleRequestImages = false;
  }
  
  async openCarConfigVehicle(carConfImporter) {
    this.carConfImporter = carConfImporter;
    this.toggleImport = false;
    return await this.carConfigModal.open();
  }

  onIsImportingChanged(isImporting: boolean) {
    if (Notification.permission !== 'granted') {
      this.importerInfoPopup = isImporting;
    } else {
      this.isImporting = isImporting;
    }
  }

  onOpenConfirmRequest(isOpen:boolean) {
    this.toggleConfirmRequestImages = isOpen;
    this.toggleRequestImages = false;
  }

  sortByImported(event) {
    this.sortByImg = event.target.checked;

    if (event.target.checked) {
      // Sort images by importStatus: "completed" first, then by position
      this.allVehicleImages.sort((a, b) => {
        const aIsCompleted = a.importStatus === 'completed';
        const bIsCompleted = b.importStatus === 'completed';

        if (aIsCompleted && !bIsCompleted) {
          return -1;
        }
        if (!aIsCompleted && bIsCompleted) {
          return 1;
        }
        return a.position - b.position;
      });
    } else {
      // When checkbox is unchecked, return list to its initial state
      this.allVehicleImages.sort((a, b) => a.position - b.position);
    }
  }
}


enum vehicleStatus {
  IMAGE_PROCESSED = 'image.processed',
  VEHICLE_PROCESSED = 'vehicle.processed',
  IMAGE_IMPORTED = 'image.imported',
  VEHICLE_IMPORTED = 'vehicle.images.imported',
}

enum Status {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  PROCESSING = 'processing',
  QC = 'qc',
  UNPROCESSED = 'unprocessed',
}

enum IMPORT_STATUS {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  IMPORTING = 'importing',
  NOT_IMPORTED = 'not_imported',
  NOT_AVAILABLE = 'not_available',
}
